import { render, staticRenderFns } from "./AddRiskPoint.vue?vue&type=template&id=24b9ddd0&scoped=true"
import script from "./AddRiskPoint.vue?vue&type=script&lang=js"
export * from "./AddRiskPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9ddd0",
  null
  
)

export default component.exports